import CreateBtn from "@components/CreateButton";
import Loader from "@components/Loader";
import ModalConfirmation from "@components/ModalConfirmation";
import Table from "@components/Table";
import Title from "@components/Title";
import { EUiStates } from "@constants/enum";
import useListColumns from "@hooks/Faq/useListColumns";
import useDeleteItem from "@hooks/Shared/useDeleteItem";
import useListItems from "@hooks/Shared/useListItems";
import listMapper from "@mappers/Modules/faq/ListFaq.mapper";
import deleteFaq from "@services/Faq/deleteFaq";
import getFaqs from "@services/Faq/getFaqs";
import { ReactElement, useEffect, useState } from "react";
import { Container } from "reactstrap";

const ListItems = (): ReactElement => {
  const [isDeletingItem, setIsDeletingItem] = useState(false);
  const { isLoading, basicData, tableItems } = useListItems(
    getFaqs,
    listMapper,
    isDeletingItem,
    true
  );
  const { isModalOpen, isDeleting, handleDelete, handleIsModalOpen } =
    useDeleteItem(basicData);
  const COLUMNS = useListColumns();

  useEffect(() => {
    setIsDeletingItem(isDeleting);
  }, [isDeleting]);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <Container>
      <ModalConfirmation
        icon="trash"
        title={`Faqs | Delete confirmation`}
        body={`Are you sure you want to remove the item:  "${basicData?.description}" ?`}
        handleConfirm={() => {
          handleDelete(deleteFaq);
        }}
        handleModalStatus={handleIsModalOpen}
        modalStatus={isModalOpen}
        modalType={EUiStates.DANGER}
      />
      <Title />
      <CreateBtn />
      <Table columns={COLUMNS} items={tableItems} />
    </Container>
  );
};

export default ListItems;
